import { render, staticRenderFns } from "./recaptchaV2.vue?vue&type=template&id=d690c020"
import script from "./recaptchaV2.vue?vue&type=script&lang=js"
export * from "./recaptchaV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports